// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"c506f100","787":"14bd77df"}[chunkId] + ".chunk.js";
};